export default "__VITE_ASSET__2c0cdbfb__"